export const addLog = (...args: any[]) => {
  if (typeof window === 'undefined') {
    return;
  }
  const w = window as any;
  if (!w.rentLogs) w.rentLogs = [];

  w.rentLogs.push(args);
};

if (window) {
  if (!(window as any).rentLog) {
    (window as any).rentLog = (last = 20) => {
      const _list = (window as any).rentLogs || [];
      const list = _list.slice(-last);
      list.map((l: any) => console.log(...l));
    };
  }
}
